import { Typography } from "@lyfegen-platform/react-common";
import { Box, Theme } from "@material-ui/core";
import FlexTypographyComponent from "../../FlexTypographyComponent";
import { agreementStatusToColor, getAgreementStatusIcon } from "../utils/status";

interface AgreementStatusProps {
	props: any;
	children: React.ReactNode;
	palette: Theme["palette"];
	t: any;
}

const Text: React.FC<AgreementStatusProps> = ({ props, palette, t }) => (
	<Typography
		type="status"
		style={{
			marginLeft: "2px",
			color: (props.status && agreementStatusToColor(props.status, palette, true)) || "black",
		}}
	>
		<FlexTypographyComponent type="status" text={t(props.status)} />
	</Typography>
);

const AgreementStatus: React.FC<AgreementStatusProps> = ({ props, children, palette, t }) => {
	return (
		<Box
			display="flex"
			alignItems="center"
			style={{
				height: "22px",
				borderRadius: "100px",
				backgroundColor: agreementStatusToColor(props.status, palette),
				padding: "3px 8px 3px 6px",
				fontWeight: 600,
				maxWidth: "fit-content",
			}}
		>
			{props.before && (
				<>
					<Text props={props} palette={palette} t={t} children={children} />
					&nbsp;
				</>
			)}
			{getAgreementStatusIcon(props.status)}
			{!props.before && (
				<>
					<Text props={props} palette={palette} t={t} children={children} />
				</>
			)}
		</Box>
	);
};

export default AgreementStatus;
